import React from "react";
import PropTypes from "prop-types";
import styled from "styled-components";

const Wrapper = styled.div`
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;
  height: 100vh;
  box-sizing: border-box;
  background-color: #1c355e;
  width: 100vw;
`;

const AuthPageTemplate = ({ children, ...props }) => {
  return <Wrapper {...props}>{children}</Wrapper>;
};

AuthPageTemplate.propTypes = {
  children: PropTypes.any.isRequired
};

export default AuthPageTemplate;
